<template>
  <div class="recognized-by__wrapper">
    <homepage-swiper-with-logos
      :logos="$options.consts.LOGOS_SETTINGS_SECTION_1"
      :swiper-pagination-custom-class="
        $options.consts.PAGINATION_CUSTOM_CLASS.SECTION_1
      "
      :enlarge-slide-on-interaction="true"
      class="recognized-by__first-carousel"
    />

    <homepage-swiper-with-logos
      :logos="$options.consts.LOGOS_SETTINGS_SECTION_2"
      :autoplay-delay="$options.consts.AUTOPLAY_DELAY_SECOND_SECTION"
      :swiper-pagination-custom-class="
        $options.consts.PAGINATION_CUSTOM_CLASS.SECTION_2
      "
      :enlarge-slide-on-interaction="true"
      class="recognized-by__second-carousel"
    />
  </div>
</template>

<script>
import HomepageSwiperWithLogos from '@/components/_homepage/shared/HomepageSwiperWithLogos/index.vue'
import {
  LOGOS_SETTINGS_SECTION_1,
  LOGOS_SETTINGS_SECTION_2,
  PAGINATION_CUSTOM_CLASS
} from '@/components/_homepage/HomepageRecognizedBySection/HomepageRecognizedByCarousel/enums'

const AUTOPLAY_DELAY_SECOND_SECTION = 2500

export default {
  name: 'HomepageRecognizedByCarousel',
  components: { HomepageSwiperWithLogos },
  consts: {
    LOGOS_SETTINGS_SECTION_1,
    LOGOS_SETTINGS_SECTION_2,
    PAGINATION_CUSTOM_CLASS,
    AUTOPLAY_DELAY_SECOND_SECTION
  }
}
</script>

<style lang="scss" scoped>
.recognized-by__wrapper {
  .recognized-by__second-carousel {
    $margin-top: (
      $above-desktop-xl: 79px,
      $desktop-sm: 60px,
      $mobile: 22px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }
}
</style>
